import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { rowClassSymbol } from '../types';
import MemoDataCell from './DataCell';
import { StyledDataRow } from './Table';
import { useTimeMeasurement } from './utils';
var DataRow = function (_a) {
    var _b;
    var columns = _a.columns, rowData = _a.rowData, rowIndex = _a.rowIndex, uxState = _a.uxState, allowRowSelect = _a.allowRowSelect, allowRowSelectOnAction = _a.allowRowSelectOnAction, onUxChange = _a.onUxChange, onRowClick = _a.onRowClick, onRowAction = _a.onRowAction, displayColumnsWidth = _a.displayColumnsWidth, groups = _a.groups, isEven = _a.isEven;
    var isChecked = !!((_b = uxState.checkedRows) === null || _b === void 0 ? void 0 : _b[rowData.id]);
    var handleRowAction = React.useCallback(function (id, field, value, rowData) {
        onRowAction === null || onRowAction === void 0 ? void 0 : onRowAction(id, field, value, rowData);
        if (allowRowSelectOnAction) {
            onUxChange === null || onUxChange === void 0 ? void 0 : onUxChange('selectedRow', id);
        }
    }, [onRowAction, allowRowSelectOnAction, onUxChange]);
    var handleRowClick = React.useCallback(function (e) {
        // test whether I should trigger event or not (because of possible button/link/input/etc in cell)
        var classes = Object.values(e.target.classList);
        if (!classes.includes('dataRow') && !classes.includes('cell'))
            return;
        if (onUxChange && allowRowSelect)
            onUxChange('selectedRow', rowData.id);
        if (onRowClick)
            onRowClick(rowData.id, rowData);
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [onRowClick, onUxChange, rowData]);
    var _c = useTimeMeasurement({ handleRowClick: handleRowClick }), handleMouseDown = _c.handleMouseDown, handleMouseUp = _c.handleMouseUp;
    var rowClassName = React.useMemo(function () {
        var classes = ['dataRow'];
        if (isChecked)
            classes.push('checked');
        if (uxState.selectedRow === rowData.id && (allowRowSelect || allowRowSelectOnAction))
            classes.push('selected');
        if (rowData[rowClassSymbol])
            classes.push(rowData[rowClassSymbol] || '');
        return classes.join(' ');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isChecked, uxState, rowData]);
    return (_jsx(StyledDataRow, { className: rowClassName, hasRowClick: !!onRowClick, onMouseDown: handleMouseDown, onMouseUp: handleMouseUp, isEven: !!isEven, children: columns.map(function (column, key) { return (_jsx(MemoDataCell, { column: column, rowData: rowData, rowIndex: rowIndex, onRowAction: handleRowAction, displayColumnWidth: displayColumnsWidth[column.name], group: groups === null || groups === void 0 ? void 0 : groups[key] }, column.name)); }) }));
};
export default DataRow;
